import React, { useMemo, useState } from 'react';
import { Button } from 'antd';
import { AndroidOutlined, AppleOutlined, MenuOutlined, ReloadOutlined } from '@ant-design/icons';
import PlayStoreModal from '../../modals/play-store/PlayStoreModal';
import NotificationsDropdown from './NotificationsDropdown';
import ProfileDropdown from './ProfileDropdown';
import LanguageSwitcher from '../intl/LanguageSwitcher';
import useScreenType from '../../hooks/context/useScreenType';
import useAppState from '../../hooks/context/useAppState';
import usePermissions from '../../hooks/auth/usePermissions';
import useBrand from '../../hooks/context/useBrand';

function Header() {
  const { isDesktop, isMobile } = useScreenType();
  const { setShowSideBar } = useAppState();
  const { isMerchant } = usePermissions();
  const brand = useBrand();

  // The QR codes point at the FoodAmigos dashboard app, which ships a single
  // build and has no per-partner id — so a partner brand is offered nothing
  // rather than someone else's app.
  const showsAppDownloads = !brand?.isWhiteLabel;

  const [showPlayStoreModal, setShowPlayStoreModal] = useState(false);

  const renderPlayStoreModal = useMemo(
    () => <PlayStoreModal open={showPlayStoreModal} toggle={setShowPlayStoreModal} />,
    [showPlayStoreModal],
  );

  if (!isDesktop) {
    return (
      <div className="sticky top-0  px-md h-[70px] items-center grid grid-cols-3 border-b bg-white">
        <div>
          <Button className="mr-md px-xs" onClick={() => setShowSideBar(true)}>
            <MenuOutlined />
          </Button>
        </div>
        <Button className="w-fit mx-auto" onClick={() => window.location.reload()}>
          <ReloadOutlined />
        </Button>
        <div className="flex justify-end items-center gap-4">
          {!isMobile && <LanguageSwitcher />}
          <NotificationsDropdown />
          <ProfileDropdown />
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 flex justify-between px-md z-[100] h-[70px] items-center border-b bg-white">
      <Button className="px-xs" onClick={() => setShowSideBar((current) => !current)}>
        <MenuOutlined />
      </Button>
      <div className="flex items-center gap-4">
        {showsAppDownloads && (
          <Button onClick={() => setShowPlayStoreModal(true)}>
            <AndroidOutlined />
            <AppleOutlined />
          </Button>
        )}
        <div className="flex items-center gap-4">
          <LanguageSwitcher />
          {isMerchant && <NotificationsDropdown />}
          <ProfileDropdown />
        </div>
      </div>
      {showsAppDownloads && renderPlayStoreModal}
    </div>
  );
}

export default Header;
